import { useState } from 'react';
import { recipeService } from '../services/recipeService';

/**
 * Hook personalizado para manejar la lógica de guardado de recetas
 * Encapsula la lógica de create/update que se repite en múltiples componentes
 */
export const useRecipeSave = () => {
    const [isSaving, setIsSaving] = useState(false);
    const [error, setError] = useState(null);

    const saveRecipe = async (data, recipeId = null, onSuccess = null) => {
        setIsSaving(true);
        setError(null);

        try {
            let response;
            if (recipeId) {
                // Modo edición
                response = await recipeService.updateRecipe(recipeId, data);
            } else {
                // Modo creación
                response = await recipeService.createRecipe(data);
            }

            if (response.success) {
                // Si hay un callback onSuccess, ejecutarlo con la receta guardada
                if (onSuccess) {
                    await onSuccess(response.recipe);
                }
                return response;
            } else {
                throw new Error('Error al guardar la receta');
            }
        } catch (err) {
            const errorMessage = err.message || 'Error al guardar la receta';
            setError(errorMessage);
            throw err;
        } finally {
            setIsSaving(false);
        }
    };

    return {
        saveRecipe,
        isSaving,
        error
    };
};





